import React from 'react';

interface AuthorBylineProps {
  lastUpdated?: string;
  reviewedBy?: string;
  showDisclaimer?: boolean;
}

const AuthorByline: React.FC<AuthorBylineProps> = ({
  lastUpdated,
  reviewedBy = 'LiberaCure Editorial Team',
  showDisclaimer = true,
}) => {
  const formattedDate = lastUpdated
    ? new Date(lastUpdated).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    : null;

  return (
    <div className="mt-16 pt-8 border-t border-warm-200 text-sm text-warm-500 space-y-3">
      <p>
        <span className="font-medium text-forest-800">{reviewedBy}</span>
        {formattedDate && (
          <span className="ml-2 text-warm-400">· Last updated {formattedDate}</span>
        )}
      </p>
      {showDisclaimer && (
        <p className="text-xs text-warm-500 leading-relaxed max-w-3xl">
          <span className="font-semibold text-warm-700">Medical disclaimer:</span> LiberaCure is a routing front-end for licensed Indian generic pharmacies. We are not pharmacists, doctors, or licensed dispensers. Information on this page is educational only and is not a substitute for professional medical advice, diagnosis, or treatment. Consult a qualified healthcare provider before starting, changing, or stopping any medication.
        </p>
      )}
    </div>
  );
};

export default AuthorByline;
